import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { myBusinesses } from "constants/apiUrls";
const businessListApi = createApi({
  reducerPath: "businessList",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_SERVER_URL }),
  endpoints: (builder) => ({
    businessList: builder.query<Array<EntityType>, void>({
      query: (data) => {
        const mandatoryHeaders = {
          "bludot-app-name": "business-rewards",
          "Content-Type": "application/json",
          Authorization: `Bearer ${JSON.parse(
            localStorage.getItem("token") || ""
          )}`,
        };
        return {
          url: myBusinesses,
          headers: mandatoryHeaders,
        };
      },
    }),
  }),
});

export const { useBusinessListQuery, useLazyBusinessListQuery } =
  businessListApi;
export default businessListApi;
